import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/marketing/Navbar";
import Footer from "@/components/marketing/Footer";
import AITutor from "@/components/AITutor";

export default function MarketingLayout() {
  return (
    <div className="min-h-screen bg-rice flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <AITutor />
    </div>
  );
}
